<template>
    <div>
        <modal-vue :title='$t("checkout.addressEdit")'
                   :show="showModal"
                   @close="showModal = !showModal"
                   width="lg">

            <address-edit v-if="! isLoading" :address="address"
                          :countries="countries"
                          :default-country-id="defaultCountryId"
                          :get-address-link="getAddressLink"
                          @address-updated="refreshAddressItem"
                          @closeModal="closeModal"
            ></address-edit>

            <div class="row" v-if="isLoading">
                <div class="col my-4 text-center">
                    <img class="mx-auto" style="height: 25px;" alt="loading icon..." src="/themes/brekz-2017/img/loading-indicator-l.gif">
                    <b class="ml-1 my-auto">{{ $t("checkout.loading") }}</b>
                </div>
            </div>
        </modal-vue>
    </div>
</template>

<script>
import AddressEdit from "./AddressEdit";
import ModalVue from "./ModalVue";
import axios from "axios";

export default {
        name: "CheckoutAddressEditModal",
        components: {
            AddressEdit,
            ModalVue,
        },
        props: {
            defaultCountryId: Number,
            getAddressLink: String,
            addressId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                address: null,
                addresses: [],
                countries: [],
                showModal: true,
                isLoading: false,
            }
        },
        mounted() {
            this.getAddresses();
        },
        methods: {
            getAddresses() {
                this.isLoading = true;

                axios.put(`${this.getAddressLink}?action=all`, JSON.stringify(this.addressData))
                     .then(response => {
                         this.addresses = response.data.addresses;
                         this.countries = response.data.countries;

                         const currentAddresses = response.data.addresses.filter((address) => parseInt(address.id_address) === this.addressId);
                         this.address           = currentAddresses[0];
                         this.isLoading         = false;
                     })
                     .catch((error) => {
                         window.brekzModal({ title: ':(', content: 'We are unable to get your saved addresses, please try again later.'}, { show: true, size: 'lg' } );

                         console.log('Address fetch failed', XMLHttpRequest.responseText);
                     });
            },
            closeModal(value){
                updateAddressesDisplay();
                this.showModal = false;
                if (value) {
                    window.location.reload();
                }
            },
            refreshAddressItem() {
                // ToDo: Refresh data in checkout.
            }
        },
    }
</script>
